import { TwinDictionary } from '../../../globals/dictionary'
import useTwinTranslation from '../../useTwinTranslation'

const useSellTicketStatusType = () => {
    const { t } = useTwinTranslation()
    const sellTicketStatus: TwinDictionary = {
        1: { name: t('saved', 'Guardado'), id: 1 },
        2: { name: t('reservedM', 'Reservado'), id: 2 },
        3: { name: t('charged', 'Cobrado'), id: 3 },
        4: { name: t('partialRefundedShort', 'Dev. parcial'), id: 4 },
        5: { name: t('refunded', 'Devuelto'), id: 5 },
        6: { name: t('canceled', 'Cancelado'), id: 6 },
    }
    return { sellTicketStatus }
}

export default useSellTicketStatusType
